import React from "react";

// All pages that rely on 3rd party components (other than Bootstrap) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
import DashboardLayout from "./layouts/Dashboard";
import Page404 from "./pages/Page404";
import OverviewHandler from "./pages/OverviewHandler";
import Print from "./pages/Print";
import Preface from "./pages/Preface";
import TotalenPrint from "./pages/TotalenPrint";

// Pages

const routes = [
    {
        path: "/",
        element: <DashboardLayout/>,
        children: [
            {
                path: "/:id/overview",
                element: <OverviewHandler/>
            },
            {
                path: "/:id/totalenprint",
                element: <TotalenPrint/>
            },
            {
                path: "/:id/preface",
                element: <Preface/>
            },
            {
                path: "/:id/print",
                element: <Print/>
            },
        ],
    },
    {
        path: "*",
        element: <Page404/>
    }
]

export default routes;
